import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IDateResult, INotification } from '@vivli/shared/features/notification/infrastructure/interface';
import { INotificationApi } from '@vivli/core/infrastructure/interface';

export const useNotificationApi = (): INotificationApi => {
    const { handleGet, handlePost, handlePut } = useAuthRestApi();
    const getNotification = (notificationId: string): Observable<INotification> => {
        return handleGet<INotification>(`/notifications/${notificationId}`);
    };

    const getNotificationsForTopic = (topicId: string): Observable<INotification[]> => {
        return handleGet<INotification[]>(`/notifications/${topicId}/topic`);
    };

    const createNotification = (notification: INotification): Observable<INotification> => {
        return handlePost<INotification>(`/notifications/`, notification);
    };

    const updateNotification = (notification: INotification): Observable<INotification> => {
        return handlePut<INotification>(`/notifications/`, notification);
    };

    const getLastAndNextDate = (notificationId: number): Observable<IDateResult> => {
        return handleGet<IDateResult>(`/notifications/${notificationId}/lastAndNextDates`);
    };

    return {
        getNotification,
        getNotificationsForTopic,
        createNotification,
        updateNotification,
        getLastAndNextDate
    };
};
